<template>
    <div v-if="ObjSpinnerState.isOn" class="loader-wrapper">
        <div class="loader"></div>
    </div>
</template>

<script>
  import ObjSpinnerState from "@/components/common/spinner/ObjSpinnerState";

  export default {
    data() {
      return {
        ObjSpinnerState: ObjSpinnerState
      };
    },
    methods: {}
  };
</script>

<style lang="scss" scoped>

</style>
